import { generatePath, Link } from 'react-router'
import { useMediaQuery } from 'usehooks-ts'

import { BlogPost } from '@entities/Blog'

import { URL_BLOG_POST } from '@shared/contants'
import { cn } from '@shared/lib/cn'
import WatchCount from '@shared/ui/watch-count'
import { formatDate } from '@shared/uttils/formatDate'

import styles from './styles.module.scss'




interface ArticleCardProps {
  data: BlogPost;
  isBigCard?: boolean;
  className?: string;
}

export default function ArticleCard (props: ArticleCardProps) {
  const { className, data, isBigCard } = props
  const isTablet = useMediaQuery('(max-width: 1280px)')

  const category = props.data?.category

  const link = generatePath(URL_BLOG_POST, {
    categorySlug: category?.slug || 'article',
    slug: data?.slug || '',
  })

  return (
    <article
      className={cn(styles.root, className, {
        [styles._big]: isBigCard,
      })}
    >
      <Link to={link}>
        <img
          className={styles.root__img}
          src={data?.preview?.url || ''}
          alt=""
          loading="lazy"
          fetchPriority="low"
        />
        <div className={styles.root__content}>
          <div className={styles.root__top}>
            { category && (
              <span className={styles.root__tag}>
                {category?.title}
              </span>
            )}
            <span className={styles.root__date}>
              {formatDate(data?.publishedAt)}
            </span>
          </div>
          <h3 className={styles.root__title}>{data?.title}</h3>
          {isBigCard && !isTablet && (
            <p className={styles.root__desc}>{data?.lead}</p>
          )}
          <WatchCount countValue={data?.viewsCount || 1} />
        </div>
      </Link>
    </article>
  )
}
